// extracted by mini-css-extract-plugin
module.exports = {"field":"Textarea_field__2ksRe","label":"Textarea_label__1xniU","textarea":"Textarea_textarea__qpEzq","textarea_error":"Textarea_textarea_error__UAR45"};